import MultiVariantBundleItem from './components/MultiVariantBundleItem';

import type { ComponentsMultiVariantBundle } from 'queries/graphql';

import styles from './styles.module.scss';

export default function MultiVariantBundle({
  sectionId,
  offerContainers,
  style,
}: ComponentsMultiVariantBundle) {
  return (
    <div id={sectionId} className={styles.container} data-cy="multi-variant-bundle">
      {offerContainers?.map(offerContainer => (
        <MultiVariantBundleItem {...offerContainer} key={offerContainer.id} style={style} />
      ))}
    </div>
  );
}
